import { render, staticRenderFns } from "./SidebarHorizontalRoot.vue?vue&type=template&id=e02880ba"
import script from "./SidebarHorizontalRoot.vue?vue&type=script&lang=js"
export * from "./SidebarHorizontalRoot.vue?vue&type=script&lang=js"
import style0 from "./SidebarHorizontalRoot.vue?vue&type=style&index=0&id=e02880ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports